module.exports = __webpack_public_path__ + "static/media/carpenter.3aff910a.svg";